import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import NewsHeader from "./components/NewsHeader";
import Footer from "./components/Footer";
import Home from "./components/Home";
import CategoryPage from "./components/CategoryPage";
import SearchResults from "./components/SearchResults";
import CategoriesPage from "./components/CategoriesPage";
import Special from "./components/Special";
import TopNews from "./components/TopNews";
import Politic from "./components/Politic";
import Business from "./components/Business";
import Technology from "./components/Technology";
import Sport from "./components/Sport";
import Entertainment from "./components/Entertainment";
import Health from "./components/Health";
import Contact from "./components/Contact";
import Login from "./components/Login";
import EPaper from "./components/EPaper";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import "bootstrap-icons/font/bootstrap-icons.css";

// ✅ Admin Pages
import AdminLayout from "./Admin/AdminLayout";
import Dashboard from "./Admin/Dashboard";
import AddNews from "./Admin/AddNews";
import ManageNews from "./Admin/ManageNews";
import User from "./Admin/User";
import AdminEPaper from "./Admin/AdminEPaper";

// ✅ User Panel Pages
import UserLayout from "./UserPanel/UserLayout";
import UserPanel from "./UserPanel/UserPanel";
import UserAddNews from "./UserPanel/UserAddNews";
import UserManageNews from "./UserPanel/UserManageNews";

function LayoutWrapper() {
  const location = useLocation();

  // ✅ Proper check to hide Header/Footer on Admin, User Panel and Auth pages
  const hideHeaderFooter =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/user-panel") ||
    ["/login", "/forgot-password", "/reset-password"].includes(location.pathname);

  return (
    <>
      {!hideHeaderFooter && <NewsHeader />}

      <Routes>
        {/* ✅ Public Routes */}
        <Route path="/" element={<Home />} />

        {/* ✅ FIXED ROUTES */}
        <Route path="/politics" element={<Politic />} />
        <Route path="/sports" element={<Sport />} />

        <Route path="/business" element={<Business />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/entertainment" element={<Entertainment />} />
        <Route path="/health" element={<Health />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/special" element={<Special />} />
        <Route path="/top-news" element={<TopNews />} />
        <Route path="/category/:category" element={<CategoryPage />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/epaper" element={<EPaper />} />

        {/* Forgot Password Routes */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* ✅ Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="add-news" element={<AddNews />} />
          <Route path="manage-news" element={<ManageNews />} />
          <Route path="epaper" element={<AdminEPaper />} />
          <Route path="user" element={<User />} />
        </Route>

        {/* ✅ User Panel Routes */}
        <Route path="/user-panel" element={<UserLayout />}>
          <Route index element={<UserPanel />} />
          <Route path="add-news" element={<UserAddNews />} />
          <Route path="manage-news" element={<UserManageNews />} />
        </Route>
      </Routes>

      {!hideHeaderFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <LayoutWrapper />
    </Router>
  );
}

export default App;